import React from "react";
import { Clip, ClipSource } from "@clarkinc/zest-design-system";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { ExpandedDescriptionTextSection } from "~/ProductDetails/ProductDetailPageResult";
import { Video } from "~/common/Store/models/Video";
interface SectionProps {
  section: ExpandedDescriptionTextSection;
  videoClassNames?: string;
}
const cdnUrlPrefix = "https://cdn.webstaurantstore.com";
const getVideoType = (file: string) => {
  const fileExt = file.split(".").pop();
  if (fileExt === "webm") {
    return "video/webm";
  }
  return "video/mp4";
};
function getClipSources(video: Video) {
  if (!video?.videoPath || !video?.sources) {
    return [];
  }
  const clipSources: ClipSource[] = [{
    src: `${cdnUrlPrefix}${video.videoPath}${video.sources.high}`,
    type: getVideoType(video.sources.high),
    priority: 1
  }, {
    src: `${cdnUrlPrefix}${video.videoPath}${video.sources.medium}`,
    type: getVideoType(video.sources.medium),
    priority: 2
  }, {
    src: `${cdnUrlPrefix}${video.videoPath}${video.sources.low}`,
    type: getVideoType(video.sources.low),
    priority: 3
  }, {
    src: `${cdnUrlPrefix}${video.videoPath}${video.sources.product}`,
    type: getVideoType(video.sources.product),
    priority: 4
  }, {
    src: `${cdnUrlPrefix}${video.videoPath}${video.sources.ipad}`,
    type: getVideoType(video.sources.ipad),
    priority: 5
  }];
  return clipSources;
}
const Section = ({
  section,
  videoClassNames
}: SectionProps) => {
  return <>
      {!!section.image.length && <div className={`template-image${section.imageHasPadding ? " exp-crop-padding" : ""}`} aria-hidden="true">
          <NoScriptLazyImage alt="" src={section.image} className="expanded-img expanded-large lazyLoad b-loaded" />
        </div>}
      {!!section.video && !!section.video.sources && !!section.video.videoPath && <div className={`flex-[0_0_auto] ${videoClassNames}`}>
          <Clip altText={section.video.title ?? ""} className="max-w-sm max-h-sm" data-testid="expanded-description-clip" loops={section.isVideoRepeating ? 5 : 1} poster={`${cdnUrlPrefix}${section.video.poster}`} sources={getClipSources(section.video)} />
        </div>}
      <div className="template-text">
        {section.headline && <h3 className="item-header"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: section.headline
      }} />}
        {section.body && <p
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: section.body
      }} />}
      </div>
    </>;
};
export default Section;